<template>
  <div class="page-container">
    <div class="login-card">
  <h2 class="login-title">
  {{ signingInMessage || "Sign In" }}
</h2>


      <div v-if="loginErrorMessage" class="alert alert-danger" role="alert">
        {{ loginErrorMessage }}
      </div>
      <button
        @click="login('azure')"
        class="oauth-btn microsoft"
        :disabled="loadingProvider === 'azure'"
      >
        <template v-if="loadingProvider !== 'azure'">
          <img src="../assets/icons/microsoft.svg" class="oauth-icon" />
          Continue with Microsoft
        </template>

        <span v-else class="loader"></span>
      </button>

      <button
        @click="login('github')"
        class="oauth-btn github"
        :disabled="loadingProvider === 'github'"
      >
        <template v-if="loadingProvider !== 'github'">
          <img src="../assets/icons/github.svg" class="oauth-icon" />
          Continue with GitHub
        </template>

        <span v-else class="loader"></span>
      </button>

      <button
        @click="login('linkedin')"
        class="oauth-btn linkedin"
        :disabled="loadingProvider === 'linkedin'"
      >
        <template v-if="loadingProvider !== 'linkedin'">
          <img src="../assets/icons/linkedin.svg" class="oauth-icon" />
          Continue with LinkedIn
        </template>

        <span v-else class="loader"></span>
      </button>
    </div>
  </div>
</template>

<script>
import { pageViews } from "../utils/util.js";
import { onMounted } from "vue";
import { THEME_KEY, THEMES } from "../composables/useTheme";

import "vue3-toastify/dist/index.css";

export default {
  authSource: "",
  name: pageViews.LOGINVIEW,
  data() {
    return {
      loginErrorMessage: "",
      loadingProvider: null,
      signingInMessage: null,

    };
  },
  methods: {
    getEnvironment() {
      const hostname = window.location.hostname;
      if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "local";
      }
      return "unknown";
    },
    async login(source) {
      this.loadingProvider = source; // show spinner

  this.signingInMessage = "Signing you in...";

      // Hold spinner for at least 2 seconds
      await new Promise((resolve) => setTimeout(resolve, 2000));

      if (this.getEnvironment() === "local") {
        this.$router.push({
          path: "/callback",
          query: {
            data: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImdwcmFiaHVAcHN5bmNvcGF0ZS5jb20iLCJuYW1lIjoiR2FuZXNoIFByYWJodSIsInN0YXR1cyI6InN1Y2Nlc3MiLCJhdXRoU291cmNlIjoiQVpVUkUiLCJleHBpcnlfdHMiOiIyMDI2LTAxLTE2IDA1OjI2OjMyIiwicm9sZSI6InN1cGVyYWRtaW4ifQ.qmaMyHpCuGD99AHTe3cz_AyWh8Baom7TGzTtOgZqfqY",
            //error: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImdhbmVzaHByYWJodXMiLCJuYW1lIjoiR2FuZXNoIFByYWJodSIsInN0YXR1cyI6InN1Y2Nlc3MiLCJhdXRoU291cmNlIjoiR0lUSFVCIiwiZXhwaXJ5X3RzIjoiMjAyNS0wMS0yMCAxMDo0NDo0MSIsInJvbGUiOiJhZG1pbiIsImVycm9yIjoidGVzdCJ9.sCbQ_s7jBS0sMlSHf2oR0jE6Im1MdUjYkKwJ8CvMuPQ"
          },
        });
      } else {
        window.location.href =
          this.$acclConfigs["authentication_api_url"] +
          "/login?authSource=" +
          source;
      }
    },
    verifyValidUser() {
      const params = new URLSearchParams(window.location.search);
      console.log("Data ", params.get("error"));
      this.loginErrorMessage = params.get("error");
    },
  },
  mounted() {
    this.verifyValidUser();
  },
  setup() {
    onMounted(() => {
      localStorage.setItem(THEME_KEY, THEMES.AUTO);
    });
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 120px);
  background: var(--body-bg);
}

.login-card {
  background: var(--surface);
  padding: 40px 32px;
  border-radius: 14px;
  box-shadow: 0 6px 18px var(--shadow-soft);
  width: 350px;
  text-align: center;
  border: 1px solid var(--border-color);
}

.login-title {
  margin-bottom: 20px;
  font-size: 1.4rem;
  color: var(--text-primary);
  font-weight: 600;
}

.oauth-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  margin-bottom: 16px;

  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--surface-hover);
  color: var(--text-primary);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;

  transition: background 0.2s ease, transform 0.15s ease;
}

.oauth-btn:hover {
  background: var(--surface-active);
  transform: translateY(-2px);
}

.oauth-btn:active {
  transform: translateY(0);
}

.oauth-icon {
  width: 20px;
  height: 20px;
}

/* Provider brand highlighting */
.microsoft {
  border-left: 4px solid #00a81c;
}

.github {
  border-left: 4px solid var(--text-secondary);
}

.linkedin {
  border-left: 4px solid #0a66c2;
}

/* Error message */
.alert {
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 10px 14px;
}

.loader {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
